import { CardsContainer } from '../DashboardCard';
import { DashboardHero } from '../DashboardHero';
import { DashboardTwoColumnSection } from '../DashboardTwoColumnSection';

interface MyCartsWrapperProps {
  children: React.ReactNode;
  title?: string;
  description1?: string;
  description2?: string;
}

export const MyCartsWrapper = ({
  children,
  title = 'My orders',
  description1 = 'Get a ready-to-use set of products made for you based on your individual test results, carefully selected and divided into individual portions to provide you with a foundational support system for slowing down the aging process or select the supplements you want from our product range. Over time, depending on your test results, your subscription can change on a monthly basis to personalize around you.',
  description2 = 'Please note that by assembling the supplement sets yourself or altering the sets assembled by us you assume the responsibility for ensuring the suitability of the products to your individual clinical needs.',
}: MyCartsWrapperProps) => {
  return (
    <DashboardTwoColumnSection>
      <DashboardHero
        className="lg:max-w-100"
        title={title}
        description={
          <div>
            <p className="mb-6">{description1}</p>
            <p>{description2}</p>
          </div>
        }
      />

      <CardsContainer className="-mx-4 lg:mx-0 lg:w-full lg:max-w-165">
        {children}
      </CardsContainer>
    </DashboardTwoColumnSection>
  );
};
